import React from 'react';
import './dotmap.css';

function notSelectedStyle(loc, dotSize) {
  return {
    top: loc[0] + 'px',
    left: loc[1] + 'px',
    height: dotSize + 'px',
    width: dotSize + 'px'
  };
}
function selectedStyle(loc, height, dotSize) {
  return {
    top: loc[0] + 'px',
    left: loc[1] + 'px',
    height: dotSize + 'px',
    width: dotSize + 'px',
    opacity: 1
  };
}

function DotMap({
  image = '',
  locations = [[50, 50], [100, 50]],
  onDotSelect = () => {},
  dotSize = 30,
  selected = -1
}) {
  return (
    <div className="dotMap">
      <img src={image} alt="person" />
      {locations.map((loc, index) => {
        return (
          <div
            key={index}
            className={'dot dot' + index}
            style={
              selected === index
                ? selectedStyle(loc, dotSize)
                : notSelectedStyle(loc, dotSize)
            }
            onClick={() => onDotSelect(index)}
          />
        );
      })}
    </div>
  );
}

export default DotMap;
